import { CalendarModal } from './calendar.modal';
import { CalendarWeekComponent } from './calendar-week.component';
import { MonthComponent } from './month.component';
import { CalendarComponent } from './calendar.component';
import { MonthPickerComponent } from './month-picker.component';

export const CALENDAR_COMPONENTS = [
  CalendarModal,
  CalendarWeekComponent,
  MonthComponent,
  CalendarComponent,
  MonthPickerComponent
];

export { CalendarModal } from './calendar.modal';
export { CalendarWeekComponent } from './calendar-week.component';
export { MonthComponent } from './month.component';
export { CalendarComponent } from './calendar.component';
export { MonthPickerComponent } from './month-picker.component';
